
import Template from '../../component/Template';
import SchoolIcon from '@mui/icons-material/School';
import Api from "../../component/Api";
import React, { useState, useEffect } from 'react';
import useAuth from '../../component/useAuth';
import PeopleIcon from '@mui/icons-material/People';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {


  const isAuth = useAuth()
  const navigate = useNavigate();
  if (isAuth === false) {
    navigate("/bos/")
  }

  const [activeRecordsCount, setActiveRecordsCount] = useState(0);
  const [activeRecordsCountDis, setActiveRecordsCountDis] = useState(0);
  const [activeRecordsCountSpec, setActiveRecordsCountSpec] = useState(0);
  const [activeRecordsCountCourse, setActiveRecordsCountCourse] = useState(0);
  const [activeRecordsCountUsers, setActiveRecordsCountUsers] = useState(0);
  const [activeRecordsCountColleges, setActiveRecordsCountColleges] = useState(0); //02/04/2024
  const [userlog, setUserLogData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  //20/3/2024
  const [isviewcount, setViewCount] = useState(false);
  const [isviewlog, setViewLog] = useState(false);



  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hour}:${minute}`;
  }

  //role validation -20/3/2024
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
      const response = await http.get('/Admin/get-all-user-permissions', {params: { user_id: id }});    
     // console.log(response);
      const permissions = response.data;     
      //console.log("permissions"+response.data);  
      permissions.forEach(permission => {
       
        if (permission.name === "view-dashboardcount") {          
          setViewCount(true);
          }
                  
        if (permission.name === "view-recentuserlogs") { 
          setViewLog(true);
          }
         
        });
      } catch (error) {      
        setViewCount(false);
        setViewLog(false);
      }
    };
    access();
  }, []);

  /*useEffect(() => {
    if (!isAuth) return;

    const fetchData = async (endpoint, setStateCallback) => {
      try {
        setLoading(true);
        const { http } = Api();
        const response = await http.get(endpoint);
        if (response.data.status_code === "ERR5") {
          setStateCallback(0); // Setting the count of active records
        } else {
          const activeRecords = response.data.data.filter(record => record.status === 'active');
          setStateCallback(activeRecords.length);
        }
        setError(null); // Clearing any previous errors
      } catch (error) {
        setError('Error fetching data. Please try again later.'); // Setting error message
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Resetting loading state
      }
    };

    fetchData('/Admin/getfaculty', setActiveRecordsCount);
    fetchData('/Admin/getdiscipline', setActiveRecordsCountDis);
    fetchData('/Admin/getspecialisation', setActiveRecordsCountSpec);
  }, [isAuth]);*/



  //new api end point connected- 11/03/2024
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { http } = Api();
        const response = await http.get('/Admin/getdashboardcount');

        if (response.data.status_code === "ERR5") {
          setActiveRecordsCount(0);
          setActiveRecordsCountDis(0);
          setActiveRecordsCountSpec(0);
          setActiveRecordsCountCourse(0);
          setActiveRecordsCountUsers(0);
        } else {
          setActiveRecordsCount(response.data.facultyCount);
          setActiveRecordsCountDis(response.data.disciplineCount);
          setActiveRecordsCountSpec(response.data.specialisationCount);
          setActiveRecordsCountCourse(response.data.courseCount);
          setActiveRecordsCountUsers(response.data.usersCount);
          setActiveRecordsCountColleges(response.data.collegeCount); //02/04/2024
        }
        setError(null); // Clearing any previous errors
      } catch (error) {
        setError('Error fetching data. Please try again later.'); // Setting error message
        console.error('Error fetching data:', error);
        setActiveRecordsCount(0);
        setActiveRecordsCountDis(0);
        setActiveRecordsCountSpec(0);
        setActiveRecordsCountCourse(0)
        setActiveRecordsCountUsers(0);
        setActiveRecordsCountColleges(0); //02/04/2024
      } finally {
        setLoading(false); // Resetting loading state
      }
    };
    fetchData();

  }, []);

  //api for latest activities 11/3/2024
  useEffect(() => {
  const fetchData = async () => {
    try {
      const id1 = localStorage.getItem("id");
      const { http } = Api();
      const response = await http.get(`/Admin/getRecentUserActions/${id1}`);
      console.log(response.data.recentUserActions);
      setUserLogData(response.data.recentUserActions);
      setTotalPages(1);

    } catch (error) {
      console.error('Error fetching user log data:', error);
      setTotalPages(0);
    }
  };
  fetchData();

}, []);
// Function to format the date to a relative format
const formatRelativeDate = dateString => {
  const parsedDate = parseISO(dateString);
  return formatDistanceToNow(parsedDate, { addSuffix: true });
};



  return (
    <>
      <Template>
        {/* Container-fluid start*/}
        <div className="container-fluid">
          <div className="row mar2">

          {isviewcount && (
            <div className="col-xxl-12 col-xl-12 box-col-12">
              <div className="row g-sm-3 height-equal-2 widget-charts">
                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body primary"> <span className="f-light">Faculties</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : activeRecordsCount}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body warning"><span className="f-light">Disciplines</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : activeRecordsCountDis}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body success"><span className="f-light">Specialisations</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : activeRecordsCountSpec}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body secondary"><span className="f-light">Courses</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : activeRecordsCountCourse}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
)}
             {isviewlog && (
            <div className="col-xxl-8 col-xl-8 col-md-12 col-sm-12 notification box-col-6 ">
              <div className="card height-equal">
                <div className="card-header card-no-border">
                  <div className="header-top">
                    <h5 className="m-0">Latest Activity</h5>

                  </div>
                </div>
                <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container">
                  <ul>
                    {totalPages > 0 ? (
                       userlog.map((log, index) => (
                       
                        
                        
                     
                      <li className="d-flex">
                       <div className={`${index % 2 ? 'activity-dot-primary': 'activity-dot-warning'} zstl`}/>

                        <div className="w-100 ms-3">
                          <p className="d-flex justify-content-between mb-2">
                            <span className="date-content light-background">{formatDate(log.created_at)}</span>
                            <span>{formatRelativeDate(log.created_at)}</span></p>
                          <h6>{log.master_user_action.user_action}<span className="dot-notification" /></h6>
                          
                        </div>
                      </li> )) 
                    ) : (

                      <li className="d-flex">
                        <div className="activity-dot-primary zstl" />
                        <div className="w-100 ms-3">

                          <h6>No Log Data Available<span className="dot-notification" /></h6>

                        </div>

                      </li>
                    )
                    }
                  </ul>
                </div>
              </div>
            </div>
             )}
              {isviewcount && (
            <div className="col-xxl-4 col-xl-4 col-md-12 mt-5">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header card-no-border">
                      <div className="header-top">
                        <h5>Total Users</h5>

                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <ul className="user-list">
                        <li>

                          <div>
                            <h5 className="mb-1 text-primary">{loading ? 'Loading...' : activeRecordsCountUsers}</h5>
                          </div>
                        </li>
                        <li>

                          <div>
                            <PeopleIcon sx={{ color: '#FF3364' }} />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div></div> {/* //02/04/2024 */}
                <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header card-no-border">
                      <div className="header-top">
                        <h5>Total Colleges</h5>

                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <ul className="user-list">
                        <li>

                          <div>
                            <h5 className="mb-1 text-primary">{loading ? 'Loading...' : activeRecordsCountColleges}</h5>
                          </div>
                        </li>
                        <li>

                          <div>
                          <i class="fa fa-university" aria-hidden="true" style={{ color: '#FF3364','fontSize':'15px' }}></i>
                           
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div></div>




            </div>    )}      



          </div>
        </div>

        {/* Container-fluid Ends*/}
      </Template>
    </>




  );


};